/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Invalidcredentials2Inputs */

const en_formvalidation_invalidcredentials2 = /** @type {(inputs: Formvalidation_Invalidcredentials2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter Valid Credentials`)
};

/**
* | output |
* | --- |
* | "Enter Valid Credentials" |
*
* @param {Formvalidation_Invalidcredentials2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_invalidcredentials2 = /** @type {((inputs?: Formvalidation_Invalidcredentials2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Invalidcredentials2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_invalidcredentials2(inputs)
});
export { formvalidation_invalidcredentials2 as "formValidation_invalidCredentials" }